//const loginName = '';
//const loginId = '';
//export default {
//	loginName,
//	loginId
//}

import axios from 'axios'

const loginName = new Promise(function(resolve, reject) {
	setTimeout(function() {
		axios.post('/api/pc/getmembername').then(
			function(data) {
				resolve(data.data.data);
//				Vue.prototype.test = data.data.data.id;
//				Vue.prototype.wechat = "my wechat!";
			},
			function(error) {
				reject(error);
			}
		);
	})
});

//	Vue.prototype.changeData = function() { 
//
//		Vue.http.post('/api/pc/getmembername').then(
//			function(data) {
//				console.log(data.data.data);
//			},
//			function(error) {
//				reject(error);
//			}
//		);
//
//	}

export default {
	loginName
};
// 获取时：上面的 data.data.data
// loginName.then(res => res)